import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import Header from "../containers/Header";
import MainLayout from "../layouts/MainLayout";
import Footer from "../containers/Footer";
import BlogList from "../components/BlogList";

import { fetchArticles } from "../apis";

import { ImNeutral } from "react-icons/im";

function Blog() {
  const [articles, setArticles] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const { t } = useTranslation();

  const onFetchArticles = async () => {
    try {
      const json = await fetchArticles();
      if (json) {
        setArticles(json);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch articles:", error?.response?.data ?? error.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    onFetchArticles();
  }, []);

  return (
    <div className="bg-gray">
      <Header
        caption={t("blog_page_header_title")}
        bgImg={
          "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1655460981/blog-header-img_jqltvs.svg"
        }
      />
      <MainLayout pageCSS="insurrance-page">
        <h2 className="">{t("blog_page_caption_text")}</h2>
        {articles.length > 0 ? (
          <BlogList articles={articles} isLoading={isLoading} />
        ) : (
          <div className="text-center u-mb-small">
            <h3>{t("blog_page_no_artcle_available_text")}</h3>
            <ImNeutral size={25} />
          </div>
        )}
      </MainLayout>
      <Footer />
    </div>
  );
}

export default Blog;
